import React from 'react';
import ReactDOM from 'react-dom';
import { pdfjs } from 'react-pdf';
import { ConfigCatProvider } from 'configcat-react';

import './index.scss';
import Routers from 'routers';
import reportWebVitals from './reportWebVitals';
import { ErrorBoundary } from 'components/ErrorBoundary';
import { ConfigCatClientBridge } from 'components/ConfigCatClientBridge';
import { trackException, trackTrace } from 'utills/telemetry';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

trackTrace('App initialized Sign Later');

// ErrorBoundary only catches errors thrown during React render/lifecycle.
// These two handlers cover what it can't: errors thrown outside React (e.g.
// event handlers, timers) and unhandled promise rejections.
window.onerror = (message, _source, _lineno, _colno, error) => {
  trackException(error instanceof Error ? error : new Error(String(message)));
};

window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
  const reason = event.reason;
  trackException(reason instanceof Error ? reason : new Error(String(reason)));
});

const configCatSdkKey = process.env.REACT_APP_CONFIGCAT_SDK_KEY || '';

const app = (
  <ErrorBoundary>
    <Routers />
  </ErrorBoundary>
);

ReactDOM.render(
  <React.StrictMode>
    {configCatSdkKey ? (
      // ConfigCatClientBridge publishes the client for module-level code
      // (telemetry.ts, correlationId.ts) once it's created. Without an SDK
      // key, skip the provider entirely and render the app directly --
      // feature flag reads then fall back to their defaultValue.
      <ConfigCatProvider sdkKey={configCatSdkKey}>
        <ConfigCatClientBridge />
        {app}
      </ConfigCatProvider>
    ) : (
      app
    )}
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
